// extracted by mini-css-extract-plugin
export var connectionButton = "_bw-1";
export var connectionButtonFloating = "_bw-2";
export var connectionContainer = "_bw-0";
export var rightPanel = "_bw-6";
export var stepCard = "_bw-3";
export var stepCardSubtitle = "_bw-5";
export var stepCardText = "_bw-4";